import { makeRequest } from "../http-common";

const CompanyDataService = {
  async getById(id) {
    return makeRequest("get", `/company/${id}`);
  },
  async update(id, data) {
    return makeRequest("put", `/company/${id}`, data);
  },
};

export default CompanyDataService;
